import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "wrapper"];

  // connect() {
  //   this.inputTargets.forEach(input => { input.checked = false; });

  //   this.wrapperTargets.forEach(w => { w.innerHTML = "" });
  // }

  execute(e) {
    this.inputTargets.forEach(input => {
      if(input === e.target) return;

      input.checked = false;
    });

    this.wrapperTargets.forEach(w => { w.innerHTML = "" });

    const mainWrapper = e.target.closest(".option-nested-form-wrapper");
    const input = mainWrapper.querySelector("input[type='text']");
    const template = mainWrapper.querySelector("template");
    const targetWrapper = mainWrapper.querySelector(".wrapper");

    const val = input.value;
    const content = template.innerHTML.replace(/CORRECT_VALUE/g, val);
    targetWrapper.innerHTML = content;
  }
}
